import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin } from 'lucide-react';
import Logo from './ui/Logo';

const COLUMNS = [
  {
    title: 'Company',
    links: [
      { to: '/about', label: 'About' },
      { to: '/projects', label: 'Projects' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { to: '/services#web-development', label: 'Website Development' },
      { to: '/services#mobile-apps', label: 'Mobile App Development' },
      { to: '/services#business-apps', label: 'Business Applications' },
      { to: '/services#ai-ml', label: 'AI & Machine Learning' },
      { to: '/services#cloud-devops', label: 'Cloud & DevOps' },
      { to: '/services#eor', label: 'EOR Services' },
    ],
  },
  {
    title: 'Support',
    links: [
      { to: '/services#support', label: 'Project & Job Support' },
      { to: '/services#maintenance', label: 'Maintenance & Upgrades' },
      { to: '/contact', label: 'Talk to us' },
    ],
  },
];

const SOCIAL = [
  {
    href: 'https://www.facebook.com/share/1EdPdLUZCe/',
    label: 'Facebook',
    icon: Facebook,
  },
  {
    href: 'https://www.instagram.com/vidhuratechnologies?igsh=OGw1cTFrZmVuOTQz',
    label: 'Instagram',
    icon: Instagram,
  },
  {
    href: 'https://www.linkedin.com/company/vidhura-technologies/',
    label: 'LinkedIn',
    icon: Linkedin,
  },
];

export default function Footer() {
  return (
    <footer className="relative mt-24 border-t border-ink-200/60 dark:border-white/10 bg-white dark:bg-ink-950">
      <div className="container-x py-16 grid gap-12 lg:grid-cols-5">
        <div className="lg:col-span-2 space-y-5">
          <Logo height={44} />
          <p className="max-w-sm text-ink-500 dark:text-ink-300 text-sm leading-relaxed">
            Websites, apps, cloud and AI — built by senior engineers based in Telangana who stay
            on the phone months after go-live.
          </p>
          <address className="not-italic space-y-2 text-sm text-ink-500 dark:text-ink-300">
            <div className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
              <span>
                9-59/C, Veluma Wada, Near MR Reddy College,
                <br />
                Parkal, Hanumakonda, Telangana-506164
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              <a href="tel:+917842091427" className="hover:text-ink-900 dark:hover:text-white">
                +91 7842091427
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              <a
                href="mailto:info@vidhuratechnologies.com"
                className="hover:text-ink-900 dark:hover:text-white"
              >
                info@vidhuratechnologies.com
              </a>
            </div>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              <a
                href="mailto:support@vidhuratechnologies.com"
                className="hover:text-ink-900 dark:hover:text-white"
              >
                support@vidhuratechnologies.com
              </a>
            </div>
          </address>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <h4 className="text-xs font-semibold uppercase tracking-[0.18em] text-ink-400">
              {col.title}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-ink-600 dark:text-ink-200 hover:text-ink-900 dark:hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="hairline" />
      <div className="container-x flex flex-col md:flex-row items-center justify-between gap-4 py-6 text-xs text-ink-400">
        <p>
          &copy; {new Date().getFullYear()} Vidhura Technologies Pvt. Ltd. All rights reserved.
        </p>
        <ul className="flex items-center gap-3 md:mr-20">
          {SOCIAL.map((s) => (
            <li key={s.label}>
              <a
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-ink-200/70 dark:border-white/10 text-ink-600 dark:text-ink-300 hover:text-ink-900 dark:hover:text-white hover:bg-ink-50 dark:hover:bg-white/5 transition-colors"
              >
                <s.icon className="w-4 h-4" />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </footer>
  );
}
